import store from '@state/store.js'
export default async function(amount) {
  store.commit('signalr/INCREMENT_RETRY_COUNT', amount)
}
